import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    labelClassName,
    tileImageClassName,
    flexClassName,
    buttonClassName,
    projectTileSlotClassNames,
} from '@archipro-design/aria';

export const ProjectTile: StyleRule = ({ theme: { siteVariables } }) => ({
    display: 'inline-block',
    padding: `${pxArrayToRem([14, 14, 0, 14])} !important`,
    [`& .${tileImageClassName}`]: {
        position: 'relative',
        '& .ui-tileOverlay': {
            [`& .${flexClassName} > .${buttonClassName}`]: {
                height: pxToRem(32),
                width: pxToRem(32),
            },
        },
    },
    '& > * div': {
        color: siteVariables.colors.white[300],
    },
    [`& .${labelClassName}`]: {
        fontSize: pxToRem(14),
        color: siteVariables.colors.charcoal['350'],
        lineHeight: '100%',
    },
    [`& .${projectTileSlotClassNames.professionalName}`]: {
        color: siteVariables.colors.charcoal['350'],
    },
});

export const ProjectTileCutoff: StyleRule = () => ({
    pointerEvents: 'none',
    overflow: 'hidden',
    [`& .${tileImageClassName}`]: {
        height: pxToRem(50),
        width: '100%',
        marginBottom: '0 !important',

        '& .ui-tileOverlay': {
            [`& .${flexClassName} > .${buttonClassName}`]: {
                pointerEvents: 'none !important',
            },
        },
    },
    [`& .${labelClassName}`]: {
        display: 'none',
    },
});
